import * as Sentry from '@sentry/react';

function initialSetup(appName: string, dsn?: string) {
  if (import.meta.env.NODE_ENV !== 'development') {
    Sentry.init({
      dsn: dsn || 'https://8244b8c365482a0629bdb36b6ea8f341@o4507215555330048.ingest.us.sentry.io/4507215566340096',
      release: `${appName}@${import.meta.env.VITE_VERSION}`,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: true,
          mask: ['.sentry-mask', '[data-sentry-mask]', '.mask'],
        }),
      ],
      environment: import.meta.env.NODE_ENV,
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/ev-api(-dev|-test|-staging)?\.easyvoteapp\.com/,
        /^https:\/\/evmobileapp(dev|test|prod5)\.azurewebsites\.net/,
        /^https:\/\/admin-api(-dev|-test|-staging)?\.easyvoteapp\.com/,
        /^https:\/\/epw-api(-dev|-test|-staging)?\.easyvoteapp\.com/,
      ],
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
    });

    Sentry.setTag('build', import.meta.env.VITE_VERSION?.substring(0, 7));
  }
}

function identifyLoggedInUser(id: string, userId: string, emailAddress: string, customerId: string, customerName: string, customerState: string) {
  if (import.meta.env.NODE_ENV !== 'development') {
    Sentry.setUser({
      id,
      username: userId,
      email: emailAddress,
    });

    if (customerId) Sentry.setTag('customer_id', customerId);

    if (customerName) Sentry.setTag('customer_name', customerName);

    if (customerState) Sentry.setTag('customer_state', customerState);
  }
}

export { initialSetup, identifyLoggedInUser };
